__turbopack_context__.v({
  "footer": "footer-module-scss-module__OkR9Rq__footer",
  "icon": "footer-module-scss-module__OkR9Rq__icon",
  "icontext": "footer-module-scss-module__OkR9Rq__icontext",
  "linksection": "footer-module-scss-module__OkR9Rq__linksection",
  "locationwidget": "footer-module-scss-module__OkR9Rq__locationwidget",
  "privacy": "footer-module-scss-module__OkR9Rq__privacy",
  "socials": "footer-module-scss-module__OkR9Rq__socials",
  "time": "footer-module-scss-module__OkR9Rq__time",
  "timelocationcontainer": "footer-module-scss-module__OkR9Rq__timelocationcontainer",
  "timewidget": "footer-module-scss-module__OkR9Rq__timewidget",
  "weatherwidget": "footer-module-scss-module__OkR9Rq__weatherwidget",
  "widget": "footer-module-scss-module__OkR9Rq__widget",
  "widgetsection": "footer-module-scss-module__OkR9Rq__widgetsection",
});
